import { useCallback } from "react";
import {
  HomePageTableTab,
  getTomorrowTimestampRange,
  getOneWeekTimestampRange,
  getFilterStatus,
} from "@vendor-app/app/AdminRoute/AdminHomeRoute/utils";
import { HomeTableColumns } from "../../store/columns";
import { HomeTableFilters } from "../../store/filters";

export interface TabConfig {
  defaultColumns: HomeTableColumns.Column[];
  filters: {
    filterType: HomeTableFilters.Filter;
    value: string[];
  }[];
  dateRange: {
    startDate: number;
    endDate: number;
  };
}

/**
 * Returns a callback function that can be used outside
 * of a React function component or custom hook. This callback
 * will return the correct config based on the table tab that
 * is selected.
 */
export const useTabManager = () => {
  const { todayTimestamp, tomorrowTimestamp } = getTomorrowTimestampRange();
  const { startTimestamp, endTimeStamp } = getOneWeekTimestampRange();

  const getTabConfiguration = useCallback(
    (selectedTab: HomePageTableTab): TabConfig => {
      if (selectedTab === HomePageTableTab.ACTIVE) {
        return {
          defaultColumns: HomeTableColumns.activeTabColumns,
          filters: [
            {
              filterType: "upcomingOrderDate",
              value: [`${todayTimestamp}`, `${tomorrowTimestamp}`],
            },
            {
              filterType: "status",
              value: [getFilterStatus(HomePageTableTab.ACTIVE)],
            },
          ],
          dateRange: { startDate: todayTimestamp, endDate: tomorrowTimestamp },
        };
      }
      return {
        defaultColumns: HomeTableColumns.cancelledTabColumns,
        filters: [
          {
            filterType: "cancelledAt",
            value: [`${endTimeStamp}`, `${startTimestamp}`],
          } as HomeTableFilters.SelectedFilter,
          {
            filterType: "status",
            value: [getFilterStatus(HomePageTableTab.CANCELLED)],
          } as HomeTableFilters.SelectedFilter,
        ],
        dateRange: { startDate: endTimeStamp, endDate: startTimestamp },
      };
    },
    [todayTimestamp, tomorrowTimestamp, startTimestamp, endTimeStamp]
  );

  return { getTabConfiguration };
};
